const actionTypes = {
  setErrors: 'SET_ERRORS',
  addSingleContent: 'ADD_SINGLE_CONTENT',
  resetState: 'RESET_STATE',
  updateFileUploadStatus: 'UPDATE_FILE_UPLOAD_STATUS',
  updateFileUploadInfo: 'UPDATE_FILE_UPLOAD_INFO',
  setFileUploadError: 'SET_FILE_UPLOAD_ERROR',
  handleValidationErrors: 'HANDLE_VALIDATIONS_ERROR',
  handleRequestError: 'HANDLE_REQUEST_ERROR',
  handleRequestLoading: 'HANDLE_REQUEST_LOADING',
};

export default actionTypes;
